// extracted by mini-css-extract-plugin
export default {"wrapper":"LogTab_wrapper__h8bF0","header":"LogTab_header__qcUMQ","heading":"LogTab_heading__3hnVa"};